module.exports = __webpack_public_path__ + "static/media/ic_library_books_24px.6865129e.svg";